const capitalize = (input, separator) => {
  return input
    ? input
        .split(separator)
        .map(([f, ...rest]) => `${f.toUpperCase()}${rest.join('')}`)
        .join('')
    : input
}

const cleanUpForm = (form) =>
  // eslint-disable-next-line
  Object.fromEntries(Object.entries(form).filter(([_, v]) => v?.toString().length))

const formatMDYDateToISODate = (mdyDate) => {
  const dateArray = mdyDate.split('-')
  return [...dateArray.slice(-1), ...dateArray.slice(0, 2)].join('-')
}

const getStrapiRoute = (router, route) =>
  router.options.routes.filter((r) => r.route === route.fullPath)[0]

const groupBy = (collection, fn) =>
  collection.reduce((groups, item) => {
    const category = fn(item)
    const group = groups[category] ?? []
    return {...groups, [category]: [...group, item]}
  }, {})

export { capitalize, cleanUpForm, formatMDYDateToISODate, getStrapiRoute, groupBy }
